import { FlatList, StyleSheet, View } from 'react-native';
import React, { useState } from 'react';
import DropdownItem from './DropdownItem';
import { useBMTheme } from '../../../theme';
const Dropdown = (props) => {
    const { items, onItemSelect, selectedItem, itemTestId, containerStyle, multiSelect } = props;
    const { BMComponents, BMElevation } = useBMTheme();
    const [styles] = useState(() => dropdownStyles(BMComponents));
    // component renders
    const renderItem = (item) => {
        const { item: dropdownItem, index } = item;
        let isActive = false;
        if (selectedItem) {
            if (typeof selectedItem === 'string') {
                isActive = dropdownItem.value === selectedItem;
            }
            else {
                isActive = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.indexOf(dropdownItem.value)) !== -1;
            }
        }
        return (<DropdownItem {...dropdownItem} onItemSelect={(value) => onItemSelect === null || onItemSelect === void 0 ? void 0 : onItemSelect(value)} active={isActive} isFirst={index === 0} isLast={index === items.length - 1} multiSelect={multiSelect}/>);
    };
    const renderSeparator = () => <View style={styles.separator}/>;
    return (<View style={styles.wrapper}>
      <FlatList data={items} renderItem={renderItem} style={[styles.container, BMElevation.elevation2, containerStyle]} ItemSeparatorComponent={renderSeparator} testID={itemTestId}/>
    </View>);
};
export default Dropdown;
const dropdownStyles = (BMComponents) => StyleSheet.create({
    wrapper: {
        position: 'absolute',
        zIndex: 999,
        width: '100%',
    },
    container: {
        borderRadius: BMComponents.BMStyleCardRadiusCompact,
        borderWidth: 1,
        borderColor: BMComponents.BMStyleCardBordercolor,
        maxHeight: 217,
    },
    separator: {
        height: 1,
        backgroundColor: BMComponents.BMStyleCardBordercolor,
    },
});
